import React from "react";
// react router dom
import { Link, useNavigate } from "react-router-dom";

// components
import Typography from "../Typography/Typography";

// icons
import { AiOutlineUnorderedList } from "react-icons/ai";
import { BiMessage } from "react-icons/bi";
import { BsBoxArrowInLeft } from "react-icons/bs";

// styled components
import { Container, Icon } from "./headerStyle";
import { Wrapper } from "../../theme/GlobalStyle";
import { useGetUnreadTicketsNumber } from "../../hooks/useCrm";
import { useEffect } from "react";

const Header = ({ setFixed, isShowSidebar, setIsShowSidebar }) => {
  const navigate = useNavigate();
  const { data, isloading, refetch } = useGetUnreadTicketsNumber();
  useEffect(() => {
    refetch();
  }, []);
  const number = data?.data?.Count;
  return (
    <Container>
      <div></div>
      <Wrapper>
        <Icon
          onClick={() => {
            setIsShowSidebar(!isShowSidebar);
            setFixed(true);
          }}
        >
          <AiOutlineUnorderedList size={20} />
        </Icon>
        {/* <Link to="https://api.metanext.biz">
          <Typography size="14px" weight="bold">
            مشاهده سایت
          </Typography>
        </Link> */}
      </Wrapper>
      <div style={{ display: "flex" }}>
        <Icon>
          <Link to="/dashboard/ticket">
            <span className="tickets-number">{number}</span>
            <BiMessage size={20} color="#0062FF" fontWeight="bold" />
          </Link>
        </Icon>
        <Icon onClick={() => navigate(-1)}>
          <BsBoxArrowInLeft size={20} />
        </Icon>
      </div>
    </Container>
  );
};
export default Header;
